import { render } from "./PassingReportTypes.vue?vue&type=template&id=774e4b72&scoped=true"
import script from "./PassingReportTypes.vue?vue&type=script&lang=js"
export * from "./PassingReportTypes.vue?vue&type=script&lang=js"

import "./PassingReportTypes.vue?vue&type=style&index=0&id=774e4b72&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774e4b72"]])

export default __exports__